import HomeIcon from '@mui/icons-material/Home';
import SettingsIcon from '@mui/icons-material/Settings';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import HistoryEduIcon from '@mui/icons-material/HistoryEdu';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import NotificationsIcon from '@mui/icons-material/Notifications';
import HelpIcon from '@mui/icons-material/Help';
import HttpsIcon from '@mui/icons-material/Https';

const menuItems = {
    id: 'initial',
    type: 'group',
    children: [
        {
            id: 'dashboard',
            title: 'Dashboard',
            type: 'item',
            url: '/dashboard',
            icon: HomeIcon,
            breadcrumbs: false
        },
        {
            id: 'configuracao-agente',
            title: 'Configurar agente',
            type: 'item',
            url: '/configuracao-agente',
            icon: SettingsIcon,
            breadcrumbs: false
        },
        {
            id: 'prompt-config',
            title: 'Configurar agente - JSON',
            type: 'item',
            url: '/prompt-config',
            icon: SettingsIcon,
            breadcrumbs: false
        },
        {
            id: 'interacoes-usuarios',
            title: 'Interações usuários',
            type: 'item',
            url: '/interacoes-usuarios',
            icon: SettingsIcon,
            breadcrumbs: false
        },
        {
            id: 'notificacoes',
            title: 'Notificações',
            type: 'item',
            url: '/notificacoes',
            icon: NotificationsIcon,
            breadcrumbs: false
        },
        {
            id: 'dados-conta',
            title: 'Dados da conta',
            type: 'item',
            url: '/dados-conta',
            icon: ManageAccountsIcon,
            breadcrumbs: false
        },
        {
            id: 'seguranca',
            title: 'Segurança',
            type: 'item',
            url: '/seguranca',
            icon: VerifiedUserIcon,
            breadcrumbs: false
        },
        {
            id: 'documentacao',
            title: 'Documentação',
            type: 'item',
            url: '/documentacao',
            icon: HistoryEduIcon,
            breadcrumbs: false
        },
        {
            id: 'termos-de-uso',
            title: 'Termos de Uso',
            type: 'item',
            url: '/termos-de-uso',
            icon: ReceiptLongIcon,
            breadcrumbs: false
        },
        {
            id: 'politica-privacidade',
            title: 'Politica de Privacidade',
            type: 'item',
            url: '/politica-privacidade',
            icon: HttpsIcon,
            breadcrumbs: false
        },
        {
            id: 'ajuda',
            title: 'Ajuda',
            type: 'item',
            url: '/ajuda',
            icon: HelpIcon,
            breadcrumbs: false
        }
    ]
};

export default {
    items: [menuItems]
};